var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M8.33336 12.6433L15.9934 4.98251L17.1725 6.16085L8.33336 15L3.03003 9.69668L4.20836 8.51835L8.33336 12.6433Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }